import React, { Component } from 'react';
import { Route } from 'react-router-dom';
import { getLanguage } from "../../store/rootReducer";
import { connect } from 'react-redux';
import auth from "../../services/auth/AuthProvider";
import LoadingSpinner from '../loading-spinner/LoadingSpinner';

class PrivateRoute extends Component {

    render() {
        const { component: Component, ...rest } = this.props;

        const renderRoute = props => {
            if (auth.isAuthenticated()) {
                
                return (
                    <Component {...props} />
                );
            }

            window.sessionStorage.setItem("myblock_route", this.props.location.pathname + (this.props.location.search ? this.props.location.search : ''));
            auth.login(this.props.language);

            return (
                <LoadingSpinner />
            );
        };

        return (
            <Route {...rest} render={renderRoute} />
        );
    }
}

const mapStateToProps = (state) => {
  return {
    language: getLanguage(state)
  }
};

export default connect(
    mapStateToProps
)(PrivateRoute);